// Textos del programa de referidos (referrals). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    REFERRALS: {
      ACTIONS: {
        RELOAD: 'Recarrega',
        LOADING: 'Carregant...',
        NEW_LINK: 'Nou enllaç',
        APPLY: 'Aplica',
        RETRY: 'Torna-ho a provar',
        LINK: 'Enllaç',
        VIEW_LINKS: 'Veure enllaços',
        SAVE: 'Desa',
        SAVING: 'Desant…',
        CANCEL: 'Cancel·la',
        BONUS: 'Bonificació',
        ACTIVATE: 'Activa',
        DEACTIVATE: 'Desactiva',
        ACTIVATING: 'Activant…',
        DEACTIVATING: 'Desactivant…',
        PREVIOUS: 'Anterior',
        NEXT: 'Següent',
        FIRST_PAGE: 'Primera pàgina',
        LAST_PAGE: 'Última pàgina',
        CHANGE: 'Canvia',
        CLOSE: 'Tanca',
        CREATE_LINK: 'Crea l’enllaç',
        CREATING: 'Creant...',
      },
      RANGE: {
        ARIA: 'Període',
        DAYS: '{{n}} dies',
        ALL: 'Tot',
        FROM: 'Des de',
        TO: 'Fins a',
      },
      FUNNEL: {
        ARIA: 'Embut de referits',
        LOADING: 'Carregant l’embut',
        REDEEMED: 'Bescanvis',
        REGISTERED: 'Registrats',
        COMPLETED: 'Completats',
        CONV_TOOLTIP: 'Sobre l’etapa anterior',
        LINKS_CREATED_ONE: 'enllaç creat',
        LINKS_CREATED_OTHER: 'enllaços creats',
        PAID: 'pagats',
        REDEMPTIONS_ONE: '{{n}} bescanvi',
        REDEMPTIONS_OTHER: '{{n}} bescanvis',
        DEFAULT_PREFIX: 'Per defecte,',
        DEFAULT_SUFFIX: 'per part',
      },
      STATUS: {
        TITLE: 'Estat actual dels bescanvis',
        HINT: 'La cohort es basa en la data de bescanvi i l’estat és el d’avui. El que s’ha pagat es mesura per data de pagament.',
        PENDING_REGISTRATION: 'Pendents de registre',
        REGISTERED_UNPAID: 'Registrats sense cobrar',
        COMPLETED: 'Completats',
        EXPIRED: 'Caducats',
      },
      OWNERS: {
        TITLE: 'Convidadors',
        SUBTITLE: 'Usuaris que han generat enllaços d’invitació. Prem «Veure enllaços» per veure i editar els seus enllaços.',
        SEARCH_PLACEHOLDER: 'Cerca un convidador per nom, cognoms o correu electrònic',
        SEARCH_ARIA: 'Cerca convidadors',
        CLEAR_SEARCH: 'Esborra la cerca',
        ONLY_WITH_REDEMPTIONS: 'Només amb bescanvis',
        LOADING: 'Carregant convidadors',
        EMPTY: 'Encara no hi ha ningú que hagi generat un enllaç d’invitació.',
        COL_OWNER: 'Convidador',
        COL_LINKS: 'Enllaços',
        COL_REDEMPTIONS: 'Bescanvis',
        COL_PENDING: 'Pendents',
        COL_REGISTERED: 'Registrats',
        COL_COMPLETED: 'Completats',
        COL_EXPIRED: 'Caducats',
        COL_PAID: 'Pagat',
        COL_LAST_LINK: 'Últim enllaç',
        COL_ACTIONS: 'Accions',
        ACTIVE_COUNT_ONE: '{{n}} actiu',
        ACTIVE_COUNT_OTHER: '{{n}} actius',
        PAGINATION_ONE: 'Mostrant {{shown}} de {{total}} convidador',
        PAGINATION_OTHER: 'Mostrant {{shown}} de {{total}} convidadors',
        ROWS_PER_PAGE: 'Files per pàgina',
        ROWS_PER_PAGE_OPTION: '{{n}} files',
      },
      LINKS: {
        LOADING: 'Carregant enllaços...',
        EMPTY: 'Aquest usuari no té cap enllaç.',
        ACTIVE: 'Actiu',
        INACTIVE: 'Desactivat',
        CAMPAIGN: 'Campanya',
        CREATED_ON: 'Creat el {{date}}',
        COPY: 'Copia l’enllaç',
        COPIED: 'Enllaç copiat',
        REDEMPTIONS_ONE: 'bescanvi',
        REDEMPTIONS_OTHER: 'bescanvis',
        PENDING_SHORT: '{{n}} pend.',
        REGISTERED_SHORT: '{{n}} reg.',
        COMPLETED_SHORT: '{{n}} compl.',
        EXPIRED_SHORT: '{{n}} cad.',
        PAGER_SHOWING: 'Mostrant',
        PAGER_OF: 'de',
        PAGER_LINKS_ONE: 'enllaç',
        PAGER_LINKS_OTHER: 'enllaços',
        NOTE: 'Canviar la bonificació només afecta els bescanvis nous: a qui ja ha bescanviat se li paga el que se li va prometre. Desactivar un enllaç atura els bescanvis nous i deixa continuar els que ja estaven en curs.',
      },
      BONUS: {
        REFERRED: 'Convidat',
        OWNER: 'Convidador',
        REFERRED_EUR: 'Convidat (€)',
        OWNER_EUR: 'Convidador (€)',
        DEFAULT: 'Per defecte',
        DEFAULT_BONUS: 'Bonificació per defecte',
      },
      MODAL: {
        TITLE: 'Nou enllaç d’invitació',
        SUBTITLE: 'L’enllaç és d’un usuari concret: el que guanyin ell i el seu convidat es defineix aquí.',
        USER: 'Usuari',
        USER_PLACEHOLDER: 'Nom, cognoms o correu electrònic',
        MIN_CHARS: 'Escriu almenys dues lletres per cercar.',
        SEARCHING: 'Cercant...',
        NO_RESULTS: 'Cap usuari amb aquest nom o correu electrònic.',
        NOTE: '0 € és un import vàlid: vol dir que aquesta part no cobra. L’import queda congelat a cada bescanvi, de manera que editar-lo després no canvia el que cobra qui ja ha bescanviat.',
      },
      MESSAGES: {
        INVALID_AMOUNTS: 'Revisa els imports: han de ser números de 0 € en amunt.',
        BONUS_UPDATED: 'Bonificació actualitzada. Afecta els bescanvis nous.',
        LINK_ACTIVATED: 'Enllaç activat.',
        LINK_DEACTIVATED: 'Enllaç desactivat. Els bescanvis que ja estaven en curs continuen.',
        COPY_FAILED: 'No s’ha pogut copiar l’enllaç.',
        PICK_USER: 'Tria l’usuari a qui pertany l’enllaç.',
        LINK_CREATED: 'Enllaç creat. Ja es pot compartir.',
        NO_PERMISSION: 'No tens permís per gestionar el programa de referits.',
        LOAD_ERROR: 'No s’han pogut carregar les dades. Torna-ho a provar.',
      },
      DIAGNOSIS: {
        TAB: 'Referits',
        TITLE: 'Referits',
        REFRESH: 'Actualitzar',
        RETRY: 'Tornar-ho a provar',
        LOAD_ERROR: "No s'han pogut carregar els referits.",
        DELETED_ON: 'esborrat el {{date}}',
        ACTIVE: 'actiu',
        SAME_PERSON: 'mateixa persona',
        OTHER_PERSON: 'una altra persona',
        EARNED_INVITING: 'Guanyat convidant',
        EARNED_INVITED: 'Guanyat en ser convidat',
        PROGRAM: 'Programa actual',
        PROGRAM_VALUE: '{{amount}} · {{trips}} viatges',
        INVITEE: {
          TITLE: 'Com va entrar',
          INVITED_BY: 'convidat per',
          no_link: { TITLE: 'Sense enllaç', TEXT: "no va entrar per cap enllaç d'invitació" },
          paid: { TITLE: 'Pagat', TEXT: 'el {{date}}' },
          pending: {
            TITLE: 'Pendent',
            TEXT: 'encara no s\'ha pagat',
            TEXT_VERIFY: 'falta verificar la identitat',
            TEXT_TRIPS: '{{done}}/{{required}} trajectes',
          },
          lost_account_deleted: {
            TITLE: 'Bescanvi perdut',
            TEXT: 'el compte del bescanvi es va esborrar el {{date}}',
            TEXT_NO_DATE: 'el compte del bescanvi està esborrat',
          },
          inviter_account_deleted: {
            TITLE: 'Convidador esborrat',
            TEXT: 'qui el va convidar va esborrar el compte el {{date}}',
            TEXT_NO_DATE: 'qui el va convidar va esborrar el compte',
          },
          expired: { TITLE: 'Caducat', TEXT: 'el bescanvi va caducar' },
        },
        INVITER: {
          TITLE: 'Els seus convidats',
          EMPTY: 'Cap',
          NO_ACCOUNT: 'Sense compte',
          CAME_BACK: 'Va tornar amb un altre compte:',
          PHONE_OTHER_PERSON: 'Ara fa servir el seu telèfon:',
          OLD_PROGRAM: 'programa anterior',
          TIP_NOT_LISTED: "Si pregunta per algú que no surt aquí, aquella persona no es va registrar amb el seu enllaç.",
        },
        STEP: { DELETED: 'Compte esborrat', LINK: 'Enllaç', REGISTERED: 'Registrat', VERIFIED: 'Verificat', TRIPS: 'Viatges', PAID: 'Pagat', SUB_REJECTED: '{{count}} rebutjats', SUB_DELETED: 'esborrat {{date}}', SUB_NOT_REQUIRED: 'no cal' },
        VIEW: { ARIA: 'Com veure els convidats', BOARD: 'Tauler', LIST: 'Llista' },
        BOARD: { DONE: 'Completats', PROGRESS: 'En procés', OUT: 'Perduts' },
        TAG: {
          PAID: 'Pagat',
          TRIPS: 'Viatges {{done}} de {{required}}',
          LAST_TRIP: 'últim {{date}}',
          VERIFY: 'Falta verificar',
          REJECTED: '{{count}} rebutjats',
          SIGN_UP: 'Falta registrar-se',
          LINK_ON: 'enllaç {{date}}',
          DELETED: 'Esborrat {{date}}',
          DELETED_NO_DATE: 'Compte esborrat',
          EXPIRED: 'Caducada',
        },
        GROUP: { PAID: 'Completats', IN_PROGRESS: 'En procés', LOST: 'Compte esborrat', EXPIRED: 'Caducats' },
        FLAGS: {
          TITLE: 'Avisos',
          OTHER: 'Avís: {{code}}',
          multiple_accounts_same_phone: '{{count}} comptes amb el seu telèfon',
          dni_in_other_account: 'DNI en {{count}} comptes més',
          phone_used_by_other_person: 'telèfon usat per una altra persona',
          inviter_account_deleted: 'convidador esborrat',
        },
      },
    },
  },
};
